<template>
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class=" inpBox">
               <el-form-item label="运单编号:" prop="wayNo">
                <el-input  placeholder=""  type="textarea" v-model="searchFrom.wayNoss"></el-input>
              </el-form-item>
              <el-form-item label="所属订单:" prop="orderNo">
                <el-input  placeholder=""   type="textarea" v-model="searchFrom.orderNoss"></el-input>
              </el-form-item>
               <el-form-item label="审核状态:" prop="auditStatus">
                <el-select  v-model="searchFrom.auditStatus"   placeholder="请选择">
                   <el-option label="全部" value=""></el-option>
                   <el-option label="待审核" value="0"></el-option>
                  <el-option label="审核通过" value="1"></el-option>
                  <el-option label="审核驳回" value="2"></el-option>
                  <el-option label="不审核" value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="车牌号:" prop="vhcNo" >
                <el-input  placeholder="" maxlength="100" v-model="searchFrom.vhcNo "></el-input>
              </el-form-item>
              <el-form-item label="司机姓名:" prop="dirverName" >
                <el-input  placeholder="" maxlength="100" v-model="searchFrom.dirverName "></el-input>
              </el-form-item>
              <el-form-item label="审核类型:" prop="auditType">
                <el-select  v-model="searchFrom.auditType"   placeholder="请选择">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="手动审核" value="1"></el-option>
                  <el-option label="自动审核" value="2"></el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="申请时间:" prop="dateTime" >
                <el-date-picker
                  v-model="searchFrom.dateTime"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item> -->
              <div style="margin:10px 0 0 20px;">
              <el-form-item >
                <el-button type="primary"  @click="searchFn" btnCode="000P00VB001">查询</el-button>
              </el-form-item>
              <el-form-item >
                <el-button type="primary"  @click="resetForm" btnCode="000P00VB002" >重置</el-button>
              </el-form-item>
              </div>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       style="width: 100%" height="100%"  center border>
         <el-table-column  type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column prop="province"    label="操作" align="center" width="120">
          <template slot-scope="scope">
            <div>
            <!-- 1显示通过/驳回 ，不是1显示记录 -->
            <el-button type="text" size="small" @click="passClick(scope.row)" btnCode="000P00VB003" v-if="scope.row.auditStatus == 0&&btnFlg[0] && scope.row.auditType == 1" >审核</el-button>
            <el-button type="text" size="small" @click="recordClick(scope.row)" btnCode="000P00VB005" v-if="(scope.row.auditStatus == 1||scope.row.auditStatus ==2) && btnFlg[1]">记录</el-button>
            <!-- <el-button type="text" size="small" @click="rejectClick(scope.row)" btnCode="000P00VB004" v-if="scope.row.auditStatus == '1' && btnFlg[3]">驳回</el-button> -->
          </div>
          </template>
        </el-table-column>
        <el-table-column property="auditStatus" label="审核状态" >
          <template scope="scope">
            {{[ "待审核", "审核通过", "审核驳回" ,"不审核"][scope.row.auditStatus]}}
          </template>
        </el-table-column>
        <el-table-column property="auditType" label="审核类型" >
          <template scope="scope">
            <!-- 1手动审核  2自动审核 -->
            <div>
              <span v-if="scope.row.auditType == '1'">手动审核</span>
              <span v-if="scope.row.auditType == '2'">自动审核</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="wayNo" width="200" label="运单编号"></el-table-column>
        <el-table-column property="orderNo" width="200" label="所属订单"></el-table-column>
        <el-table-column property="weight" width="120" :formatter="emptyFn"  label="调度量"></el-table-column>
        <el-table-column property="loadingWeight" :formatter="emptyFn" width="120"  label="装车量"></el-table-column>
        <el-table-column property="valuation" width="120"  :formatter="emptyFn"   label="估值(吨)"></el-table-column>
        <el-table-column property="unloadingWeight" :formatter="emptyFn" width="120"  label="卸车量"></el-table-column>
        <el-table-column property="vhcNo" width="100"  :formatter="emptyFn" label="车牌号"></el-table-column>
        <el-table-column property="dirverName" width="100" :formatter="emptyFn"  label="司机姓名"></el-table-column>
         <el-table-column property="payee" width="160" :formatter="emptyFn"  label="收款人"></el-table-column>
         <el-table-column property="dirverMobile" width="160" :formatter="emptyFn"  label="联系电话"></el-table-column>
        <el-table-column prop="receivingTime" width="170"  :formatter="dateTimeFormat"  label="接单时间"></el-table-column>
         <el-table-column prop="outTime" width="170" :formatter="dateTimeFormat"  label="装车时间"></el-table-column>
        <el-table-column prop="arrivalTime" width="170" :formatter="dateTimeFormat"  label="卸车时间"></el-table-column>
        <!-- <el-table-column prop="auditTime"  label="申请时间" :formatter="dateTimeFormat"  align="center" ></el-table-column> -->
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!--点击记录-->
    <el-dialog title="记录"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="recordMark"
    width="550px"
    center>
      <span>
        <el-timeline>
          <el-timeline-item  v-for="(activity, index) in activities" :key="index" :color="activities.length-1 ? '#0bbd87' : ''">
            <p>审核时间：{{activity.createTime|dateFormat}}</p>
            <p>审核人：{{activity.createUserName}}</p>
            <p>审核操作：{{[ "待审核", "审核通过", "审核驳回" ,"不审核"][activity.auditStatus]}}</p>
            <p v-if="activity.auditOpinion">审核结果：{{activity.auditOpinion}}</p>
          </el-timeline-item>
        </el-timeline>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="recordMark = false"  size='mini'>取 消</el-button>
      </span>
    </el-dialog>
     <!-- 审核 -->
    <wayDrawer :rowData="addFrom"  v-if="drawerFlag"  @destroy="destroy" @successFn="successFn"> </wayDrawer>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import DonMessage from '@/utils/message'
import {
  // 列表查询
  vehicleTypeList, // 车辆类型
  cVhcNoColour // 车辆颜色
} from '@/api/consignment'
import { wayList, getAllTenantDataBySomeData, auditRecordsList } from '@/api/soc-customer'
import wayDrawer from '@/views/consignment/registerAttestation/wayDrawer.vue'
export default {
  components: {
    wayDrawer
  },
  data () {
    return {
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        auditStatus: '0',
        platformStatuss: [2004, 2005],
        noWayType: 3,
        settlementMethod: 1
      },
      total: 0,
      loading: 'false',
      zzauditStatusOptions: [], // 审核状态
      vhcNoColourOptions: [],
      vhcTypeIdOptions: [],
      // 记录
      activities: [],
      recordMark: false,
      drawerFlag: false,
      addFrom: {},
      carList: [],
      ssdw: [],
      vehicleSS: [
        {
          value: 1,
          label: '单位'
        },
        {
          value: 2,
          label: '个人'
        }
      ],
      imgList: [],
      rules: {
        vhcNo: [
          { required: true, message: '请输入车牌号', trigger: 'blur' },
          this.rule.vhcNo
        ],
        noColour: [
          { required: true, message: '请选择车牌颜色', trigger: ['blur', 'change'] }
        ],
        vehicleTenant: [
          { required: true, message: '请选择车辆所有人', trigger: 'blur' }
        ],
        vehicleTenantName: [
          { required: true, message: '请输入车辆所有人', trigger: 'blur' }
        ],
        vhcType: [{ required: true, message: '请选择车辆类型', trigger: ['blur', 'change'] }],
        vhcClassify: [{ required: true, message: '请选择车辆所属', trigger: ['blur', 'change'] }],
        drivingLicense: [{ required: true, message: '行驶证号档案号', trigger: 'blur' }],
        vhcVinNo: [{ required: true, message: '请输入车辆识别代号', trigger: 'blur' }],
        transportNo: [{ required: true, message: '请输入道路运输证号', trigger: 'blur' }],
        businessLicenseNo: [{ required: true, message: '请输道路运输经营许可证号', trigger: ['blur'] }]
      },
      btnFlg: [],
      btnIdArr: ['000P00bB001', '000P00bB002']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/registerAttestation/wayCheck')
    this.getList()
    this.vehicleTypeList()
    this.getCarColor()
    getAllTenantDataBySomeData().then(res => {
      this.ssdw = res
    })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
    // 审核
    passClick (row) {
      this.addFrom = { ...row }
      this.drawerFlag = true
    },
    successFn () {
      this.getList()
    },
    destroy () {
      this.drawerFlag = false
    },
    // 点击记录
    recordClick (row) {
      this.title = '记录'
      this.recordMark = true
      auditRecordsList({
        wayId: row.id
      }).then(res => {
        this.activities = res
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 获取车辆类型下拉框
    vehicleTypeList () {
      vehicleTypeList().then(res => {
        this.vhcTypeIdOptions = res
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    getCarColor () {
      cVhcNoColour().then(res => {
        this.vhcNoColourOptions = res
      })
    },
    // 查选
    searchFn () {
      // if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }
      if (this.searchFrom.wayNoss) { this.searchFrom.wayNos = this.searchFrom.wayNoss.split(/[(\r\n)\r\n]+/) } else {
        this.searchFrom.wayNos = ''
      }
      if (this.searchFrom.orderNoss) { this.searchFrom.orderNos = this.searchFrom.orderNoss.split(/[(\r\n)\r\n]+/) } else {
        this.searchFrom.orderNos = ''
      }
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 获取列表
    getList () {
      this.loading = true
      if (this.searchFrom.dateTime) {
        this.searchFrom.startTime = this.searchFrom.dateTime[0]
        this.searchFrom.endTime = this.searchFrom.dateTime[1]
      }
      this.loading = true
      wayList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
        this.$previewRefresh()
      }).catch(err => {
        this.loading = false
        DonMessage.error(err.message)
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        platformStatuss: [2004, 2005],
        noWayType: 3,
        settlementMethod: 1
      }
      this.getList()
    },

    closeDialog () {
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
      width: 350px!important;
}

</style>
